<template>
  <div style="padding: 25px; background-color: #fff">
    <el-tabs v-model="activeName" type="card" @tab-click="getData">
      <el-tab-pane label="今日新增公司" name="TodayNewCompany"></el-tab-pane>
      <el-tab-pane label="公司总数" name="TotalCompany"></el-tab-pane>
      <el-tab-pane label="今日新增工人" name="TodayNewUser"></el-tab-pane>
      <el-tab-pane label="工人总数" name="TotalUser"></el-tab-pane>
      <el-tab-pane label="公户开立" name="公户开立"></el-tab-pane>
      <el-tab-pane label="合作申请" name="合作申请"></el-tab-pane>
      <el-tab-pane label="联系我们" name="联系我们"></el-tab-pane>
      <el-tab-pane label="系统通知" name="系统通知"></el-tab-pane>
      <el-tab-pane label="开卡列表" name="开卡列表"></el-tab-pane>
      <el-tab-pane label="帮助中心" name="帮助中心"></el-tab-pane>
      <el-tab-pane label="资讯管理" name="资讯管理"></el-tab-pane>
      <el-tab-pane label="保险审核" name="保险审核"></el-tab-pane>
    </el-tabs>
    <el-row :gutter="20">
      <el-form
        ref="searchForm"
        :model="searchForm"
        label-width="70px"
        size="small"
        v-enterToNext="true"
      >
        <el-col :lg="4" :md="12" :sm="12" :xs="24">
          <el-form-item label="关键字" prop="keyWord">
            <el-input
              @keyup.enter.native="getData"
              v-model="searchForm.keyWord"
              clearable
              placeholder="请输入关键字查询"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :lg="4" :md="12" :sm="12" :xs="24">
          <el-form-item
            label-width="100px"
            label="是否有卡号"
            prop="isCooperation"
            v-if="titleName == '开卡列表'"
          >
            <el-select
              v-model="searchForm.isHaveCard"
              clearable
              placeholder="请选择"
              @clear="clear"
            >
              <el-option label="是" :value="true"></el-option>
              <el-option label="否" :value="false"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-form>
      <el-button
        size="small"
        style="margin-left: 15px"
        type="primary"
        plain
        @click="getData"
        icon="el-icon-search"
        >查询</el-button
      >
      <el-button
        size="small "
        icon="el-icon-refresh"
        type="success"
        v-if="titleName == '开卡列表'"
        plain
        :loading="submitLoading"
        @click="refreshState"
        >刷新状态</el-button
      >
      <div style="float: right" v-if="titleName == '系统通知'">
        <el-button
          size="mini "
          type="primary"
          plain
          @click="add"
          icon="el-icon-plus"
          >新增</el-button
        >

        <!-- <el-button
          type="primary"
          plain
          size="mini "
          @click="sort"
          icon="el-icon-refresh-right"
          >更新排序</el-button
        > -->
      </div>
    </el-row>
    <div style="display: flex">
      <div class="box" v-if="titleName && titleName.indexOf('公司') != -1">
        <div style="text-align: center">{{ titleName }}：{{ num }}</div>
        <MyTable
          :tableData="tableData1"
          :tableConfig="tableConfig1"
          height="600px"
          :indexFlag="true"
        >
          <template v-slot:index="slotData">
            {{ slotData.scope.$index + 1 }}
          </template>
        </MyTable>
      </div>
      <div class="box" v-if="titleName && titleName.indexOf('工人') != -1">
        <div style="text-align: center">{{ titleName }}：{{ num }}</div>
        <MyTable
          :tableData="tableData1"
          :tableConfig="tableConfig2"
          height="600px"
          :indexFlag="true"
        >
          <template v-slot:index="slotData">
            {{ slotData.scope.$index + 1 }}
          </template>
        </MyTable>
      </div>
    </div>
    <div v-if="titleName == '公户开立'" class="box">
      <div style="text-align: center; font-size: 22px">公户开立</div>
      <MyTable
        :tableData="tableData"
        :tableConfig="tableConfig"
        height="600px"
        :key="titleName"
        :indexFlag="true"
      >
        <template v-slot:index="slotData">
          {{ slotData.scope.$index + 1 }}
        </template>

        <template v-slot:createUserName="slotData">
          <div>
            {{ slotData.scope.row.createUserAccount }}
          </div>
          <div>
            {{ slotData.scope.row.createUserName
            }}{{
              slotData.scope.row.createUserTel
                ? "（" + slotData.scope.row.createUserTel + "）"
                : ""
            }}
          </div>
        </template>
        <template v-slot:interiorRemark="slotData">
          <div style="display: flex">
            <el-select
              v-model="slotData.scope.row.interiorRemark"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in options"
                :key="item.label"
                :label="item.label"
                :value="item.label"
              >
              </el-option>
            </el-select>
            <el-button
              size="mini"
              type="primary"
              @click="save(slotData.scope.row)"
              >保存</el-button
            >
          </div>
        </template>
        <template v-slot:moreOperation="slotData">
          <el-button
            @click="setCardState(slotData.scope.row)"
            size="small"
            type="primary"
            plain
            icon="el-icon-setting"
            >设置状态</el-button
          >
        </template>
      </MyTable>
      <Pagination
        :total="total"
        @getNewData="SendEmailLogPage"
        ref="pagination"
      />
    </div>
    <div v-if="titleName == '合作申请' || titleName == '联系我们'" class="box">
      <div style="text-align: center; font-size: 22px">{{ titleName }}</div>
      <MyTable
        :tableData="tableData"
        :tableConfig="tableConfig"
        :key="titleName"
        height="600px"
        :indexFlag="true"
      >
        <template v-slot:index="slotData">
          {{ slotData.scope.$index + 1 }}
        </template>
      </MyTable>
      <Pagination
        :total="total"
        @getNewData="titleName == '合作申请' ? ApplyPage : SuggestPage"
        ref="pagination"
      />
    </div>
    <div v-if="titleName == '开卡列表'">
      <MyTable
        :tableData="tableData"
        :tableConfig="cardConfig"
        :indexFlag="true"
      >
        <template v-slot:dataState="slotData">
          <div>
            {{ slotData.scope.row.followStateText }}
            <span v-if="slotData.scope.row.followStateTextOther"
              >（{{ slotData.scope.row.followStateTextOther }}）</span
            >
          </div>
        </template>
        <template v-slot:index="slotData">
          {{
            ($refs.pagination.currentPage - 1) * $refs.pagination.pageSize +
            slotData.scope.$index +
            1
          }}
        </template>
        <template v-slot:userWorkState="slotData">
          {{ slotData.scope.row.userWorkState | filterUserWorkState }}
        </template>
        <template v-slot:isStop="slotData">
          {{ slotData.scope.row.isStop ? "停用" : "启用" }}
        </template>
        <template v-slot:openCardState="slotData">
          <div v-if="slotData.scope.row.openCardState == 1">
            <el-tag size="small" type="danger">异常</el-tag>
          </div>
        </template>
        <template v-slot:time="slotData">
          {{
            slotData.scope.row.entryDate &&
            slotData.scope.row.entryDate.slice(0, 10)
          }}
        </template>
        <template v-slot:openCarResult="slotData">
          {{ slotData.scope.row.openCarResult ? "" : "-" }}
        </template>
      </MyTable>
      <Pagination
        :total="total"
        @getNewData="CompanyReferrerCarPage"
        ref="pagination"
      />
    </div>
    <div class="manege-right" v-if="titleName == '系统通知'">
      <MyTable
        :tableData="messageData"
        :tableConfig="messageConfig"
        tableType="selection"
        @selectionChange="selectionChange"
        height="600px"
        :indexFlag="true"
      >
        <template v-slot:index="slotData">
          {{ slotData.scope.$index + 1 }}
        </template>
        <template v-slot:sort="slotData">
          <el-input-number
            size="small"
            :precision="0"
            v-model="slotData.scope.row.sort"
            controls-position="right"
            @change="slotData.scope.row.add = '1'"
          ></el-input-number>
        </template>
        <template v-slot:operation="slotData">
          <el-button
            @click="infoEdit(slotData.scope.row)"
            size="small"
            icon="el-icon-edit"
            >编辑</el-button
          >
          <el-button
            size="mini"
            type="danger"
            plain
            @click="del(slotData.scope.row)"
            icon="el-icon-delete"
            >删除</el-button
          >
        </template>
      </MyTable>
      <Pagination :total="total" @getNewData="getData" ref="pagination" />
    </div>
    <el-dialog
      :title="type"
      :visible.sync="editVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="true"
      width="900px"
      @close="form = {}"
    >
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="80px"
        size="small"
        v-enterToNext="true"
      >
        <el-form-item label="主题" prop="title">
          <el-input v-model="form.title" maxlength="40"></el-input>
        </el-form-item>
        <el-form-item label="排序" class="number-footer">
          <el-input-number v-model="form.sort" :precision="0"></el-input-number>
        </el-form-item>
        <el-form-item label="内容">
          <el-input
            type="textarea"
            :rows="5"
            placeholder="请输入内容"
            v-model="form.messageContent"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="(editVisible = false), (form = {})">关 闭</el-button>
        <el-button type="primary" size="small" @click="onSubmit('form')"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import MyTable from "@/components/Table";
import Search from "@/components/Search";
import { showWorkState, workStateList } from "../utils/common";
export default {
  components: {
    MyTable,
    Search,
  },
  data() {
    return {
      loading: false,
      activeName: "TodayNewCompany",
      tableName: "SimpleStatistics",
      titleName: "今日新增公司",
      searchForm: {},
      tableData: [],
      tableData1: [],
      type: "",
      editVisible: false,
      rules: {
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
      },
      form: {},
      messageData: [],
      total: 0,
      num: "",
      options: [{ label: "已开户" }, { label: "未开户" }],
      tableConfig: [],
      cardConfig: [
        {
          field: "userName",
          label: "姓名",
          align: "center",
          width: 120,
          flag: true,
        },
        {
          field: "sex",
          label: "性别",
          align: "center",
          width: 90,
          flag: true,
        },
        {
          field: "identityCard",
          label: "身份证号",
          align: "center",
          width: 180,
          flag: true,
        },
        {
          field: "tel",
          label: "手机号码",
          align: "center",
          width: 140,
          flag: true,
        },
        {
          field: "userWorkState",
          label: "人员状态",
          align: "center",
          width: 120,
          flag: true,
          slotName: "userWorkState",
        },
        {
          field: "createUserName",
          label: "发起人",
          align: "center",
          width: 120,
          flag: true,
        },
        {
          field: "lastSendMsgBankName",
          label: "开卡银行",
          align: "center",
          width: 120,
          flag: true,
        },
        {
          field: "sendMsgCount",
          label: "通知次数",
          align: "center",
          width: 110,
          flag: true,
        },
        {
          field: "lastSendMsgTime",
          label: "最近通知时间",
          align: "center",

          width: 180,
          flag: true,
        },

        {
          field: "dataState",
          label: "状态",
          align: "center",

          width: 180,
          flag: true,
          slotName: "dataState",
        },
        {
          field: "cardNumber",
          label: "卡号",
          align: "center",
          width: 180,
          flag: true,
        },
        {
          field: "openCardState",
          label: "是否异常",
          align: "center",
          slotName: "openCardState",
          width: 120,
          flag: true,
        },
        {
          field: "remark",
          label: "备注",
          align: "center",
          minWidth: 180,
          flag: true,
        },
      ],
      emailConfig: [
        {
          field: "createDate",
          label: "申请时间",
          align: "center",
          flag: true,
          width: 170,
        },
        {
          field: "createUserName",
          slotName: "createUserName",
          label: "申请人",
          align: "center",
          flag: true,
          minWidth: 200,
        },
        {
          field: "bankName",
          label: "申请银行",
          width: 110,
          align: "center",
          flag: true,
        },
        {
          field: "companyName",
          label: "企业名称",
          align: "center",
          minWidth: 200,
          flag: true,
        },
        {
          field: "creditCode",
          label: "统一社会信用代码",
          align: "center",
          width: 190,
          flag: true,
        },
        {
          field: "enterpriseSite",
          label: "企业所在地",
          align: "center",
          minWidth: 200,
          flag: true,
        },
        {
          field: "contactName",
          label: "企业联系人",
          align: "center",
          flag: true,
        },
        {
          field: "contactPhone",
          label: "手机号码",
          align: "center",
          width: 140,
          flag: true,
        },
        {
          field: "interiorRemark",
          slotName: "interiorRemark",
          label: "",
          align: "center",
          fixed: "right",

          flag: true,
          width: 180,
        },
      ],
      tableConfig1: [
        {
          field: "createDate",
          label: "注册时间",
          align: "center",
          width: 200,
          flag: true,
        },
        {
          field: "refeCode",
          label: "推荐码",
          align: "center",
          width: 200,
          flag: true,
        },
        {
          field: "name",
          label: "公司名称",
          align: "center",
          width: 200,
          flag: true,
        },
        {
          field: "parkName",
          label: "园区名称",
          align: "center",
          width: 200,
          flag: true,
        },
        {
          field: "tel",
          label: "手机号码",
          align: "center",
          width: 200,
          flag: true,
        },
      ],
      messageConfig: [
        {
          field: "title",
          label: "标题",
          align: "center",
          width: 350,
          flag: true,
        },
        {
          field: "messageContent",
          label: "内容",
          align: "center",
          flag: true,
        },
        {
          field: "sort",
          label: "排序",
          align: "center",
          width: 200,
          flag: true,
        },
        {
          label: "基本操作",
          slotName: "operation",
          width: 185,
          align: "center",
          flag: true,
          fixed: "right",
        },
      ],
      tableConfig2: [
        {
          field: "createDate",
          label: "注册时间",
          align: "center",
          width: 200,
          flag: true,
        },
        {
          field: "name",
          label: "员工姓名",
          align: "center",
          width: 200,
          flag: true,
        },
        {
          field: "tel",
          label: "手机号码",
          align: "center",
          width: 200,
          flag: true,
        },
      ],
      SuggestConfig: [
        {
          field: "createDate",
          label: "申请时间",
          align: "center",
          flag: true,
          width: 170,
        },
        {
          field: "name",
          label: "姓名",
          align: "center",
          width: 200,
          flag: true,
        },

        {
          field: "email",
          label: "邮箱",
          align: "center",
          width: 250,
          flag: true,
        },
        {
          field: "subject",
          label: "主题",
          align: "center",
          width: 200,
          flag: true,
        },
        {
          field: "infoContent",
          label: "内容",
          align: "center",
          flag: true,
        },
      ],
      applyConfig: [
        {
          field: "createDate",
          label: "申请时间",
          align: "center",
          flag: true,
          width: 170,
        },
        {
          field: "name",
          label: "姓名",
          align: "center",
          width: 200,
          flag: true,
        },
        {
          field: "tel",
          label: "手机号",
          align: "center",
          width: 200,
          flag: true,
        },
        {
          field: "email",
          label: "邮箱",
          align: "center",
          width: 250,
          flag: true,
        },
        {
          field: "infoContent",
          label: "内容",
          align: "center",
          flag: true,
        },
      ],
      submitLoading: false,
      Ids: [],
    };
  },
  filters: {
    filterUserWorkState(num) {
      return showWorkState(num);
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    //添加系统通知
    add() {
      this.editVisible = true;
      this.type = "新增通知";
    },
    async infoEdit(data) {
      await this.MessageDetail(data);
      this.editVisible = true;
      this.type = "编辑通知";
    },
    async MessageDetail(data) {
      let sendData = {
        id: data.id,
      };
      await this.$api.manage.MessageDetail(sendData).then((res) => {
        if (res.error === false) {
          this.$set(this, "form", res.data);
          this.$set(
            this.form,
            "sort",
            res.data.sort == null ? undefined : res.data.sort
          );
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //删除系统通知
    del(row) {
      this.$confirm("是否删除当前记录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$api.manage.MessageDelete(row.id).then((res) => {
            if (res.code == 0) {
              this.getData();
              this.$message.success("删除成功");
            } else {
              this.$message.error(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    selectionChange(selection) {
      this.Ids = selection.map((v) => {
        return v.id;
      });
    },
    //提交系统通知
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        let sendData = {
          id: this.form.id,
          title: this.form.title,
          sort: this.form.sort,
          messageContent: this.form.messageContent,
        };
        this.$api.manage.MessageManageEdit(sendData).then((res) => {
          if (res.error === false) {
            this.$message.success("保存成功");
            this.editVisible = false;
            this.getData();
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    // 刷新状态
    async refreshState() {
      this.submitLoading = true;
      for (var i = 0; i < this.tableData.length; i++) {
        let sendData = {
          crid: this.tableData[i].id,
        };
        if (this.tableData[i].followState) {
          await this.commitRefresh(sendData);
        }
        if (i == this.tableData.length - 1) {
          this.submitLoading = false;
          this.CompanyReferrerCarPage();
          this.$message.success("刷新成功");
        }
      }
    },
    async commitRefresh(param) {
      await this.$api.user
        .CompanyReferrerCarSyncBankCardStatu(param)
        .then((res) => {
          if (res.code === 0) {
            console.log(res);
          } else if (res.code < 0) {
            this.$message.error(res.msg);
          }
        });
    },
    CompanyReferrerCarPage() {
      this.$nextTick(() => {
        this.loading = true;
        let sendData = {};
        sendData = {
          pageIndex: this.$refs.pagination.currentPage,
          pageSize: this.$refs.pagination.pageSize,
          carType: "1",
          isHaveCard: this.searchForm.isHaveCard,
          keyWord: this.searchForm.keyWord,
        };

        this.$api.user.CompanyReferrerCarPageAll(sendData).then((res) => {
          if (!res.error) {
            console.log(res);
            this.loading = false;
            this.tableData = res.data.data;
            this.total = res.data.count;
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    clear() {
      this.$set(this.searchForm, "keyWord", "");
    },
    save(row) {
      let sendData = {
        id: row.id,
        interiorRemark: row.interiorRemark,
      };
      this.$api.thirdyParty.SendEmailLogEdit(sendData).then((res) => {
        if (!res.error) {
          this.$message.success("保存成功");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getData(v) {
      if (v && v.label) {
        this.titleName = v.label;
      }
      if (this.titleName == "帮助中心") {
        this.$router.push("/helpManagement");
        return;
      }
      if (this.titleName == "保险审核") {
        this.$router.push("/InsuranceManagement");
        return;
      }
      if (this.titleName == "资讯管理") {
        this.$router.push("/informationManage");
        return;
      }
      if (
        this.titleName != "公户开立" &&
        this.titleName != "合作申请" &&
        this.titleName != "联系我们" &&
        this.titleName != "开卡列表" &&
        this.titleName != "系统通知"
      ) {
        this.loading = true;
        let sendData = {
          infoStatisticsType: this.activeName,
          keyWord: this.searchForm.keyWord,
        };
        this.$api.user.InfoStatistics(sendData).then((res) => {
          this.loading = false;
          if (res.code == 1) {
            this.$router.push("/home");
            return;
          }
          if (res.error === false) {
            // this.SendEmailLogPage();
            this.tableData1 = res.data.statisticsInfoList;
            this.num = res.data.dataCount;
          } else {
            this.$router.push("/home");

            this.$message.error(res.msg);
          }
        });
      } else if (this.titleName == "公户开立") {
        this.SendEmailLogPage();
      } else if (this.titleName == "合作申请") {
        this.ApplyPage();
      } else if (this.titleName == "联系我们") {
        this.SuggestPage();
      } else if (this.titleName == "开卡列表") {
        this.CompanyReferrerCarPage();
      } else if (this.titleName == "系统通知") {
        this.MessageMessagePage();
      }
    },
    MessageMessagePage() {
      this.$nextTick(() => {
        let sendData = {
          pageIndex: this.$refs.pagination.currentPage,
          pageSize: this.$refs.pagination.pageSize,
          keyWord: this.searchForm.keyWord,
        };

        this.$api.manage.MessagePage(sendData).then((res) => {
          if (!res.error) {
            console.log(res);
            this.messageData = res.data.pageData.data;
            this.total = res.data.pageData.count;
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    SendEmailLogPage() {
      this.$nextTick(() => {
        this.loading = true;
        let sendData = {};
        sendData = {
          pageIndex: this.$refs.pagination.currentPage,
          pageSize: this.$refs.pagination.pageSize,
          keyWord: this.searchForm.keyWord,
        };

        this.$api.email.SendEmailLogPage(sendData).then((res) => {
          if (!res.error) {
            console.log(res);
            this.tableConfig = this.emailConfig;
            this.loading = false;
            this.tableData = res.data.data;
            this.total = res.data.count;
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    ApplyPage() {
      this.$nextTick(() => {
        this.loading = true;
        let sendData = {};
        sendData = {
          pageIndex: this.$refs.pagination.currentPage,
          pageSize: this.$refs.pagination.pageSize,
          keyWord: this.searchForm.keyWord,
        };

        this.$api.manage.ApplyPage(sendData).then((res) => {
          if (!res.error) {
            console.log(res);
            this.loading = false;
            this.tableConfig = this.applyConfig;
            this.tableData = res.data.data;
            this.total = res.data.count;
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
    SuggestPage() {
      this.$nextTick(() => {
        this.loading = true;
        let sendData = {};
        sendData = {
          pageIndex: this.$refs.pagination.currentPage,
          pageSize: this.$refs.pagination.pageSize,
          keyWord: this.searchForm.keyWord,
        };

        this.$api.manage.SuggestPage(sendData).then((res) => {
          if (!res.error) {
            console.log(res);
            this.loading = false;
            this.tableConfig = this.SuggestConfig;

            this.tableData = res.data.data;
            this.total = res.data.count;
            this.$forceUpdate();
          } else {
            this.$message.error(res.msg);
          }
        });
      });
    },
  },
};
</script>


<style lang="less" scope>
.box {
  padding: 0 30px 60px 30px;
}
.manege-right {
  .search {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    .search-left {
      display: flex;
      align-items: center;
    }
  }
  .btn {
    text-align: center;
  }
  .type {
    text-align: center;
    padding-bottom: 20px;
    font-size: 18px;
  }
}
</style>

